"use strict";

require("./..\\..\\..\\bower_components\\slick-carousel\\slick\\slick.min.js");

module.exports = function () {
	$('[photo-slider]').each(function () {
		var $wrap = $(this),
			slideQuery = '[photo-slider-item]',
			$slides = $wrap.find(slideQuery),
			$slider = $('<div class="photo-slider">'),
			$navSlider = $('<div class="photo-slider-nav">');

		$slides.each(function () {
			var $slide = $(this),
				$bigSlide = $('<img src="'+$slide.attr('href')+'">');

			$slider.append($bigSlide);
			$navSlider.append($slide);
		});

		$wrap.append($slider, $navSlider);


		$slider.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: $navSlider
		});

		$navSlider.slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			focusOnSelect: true,
			dots : false,
			prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous"></button>',
			nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next"></button>',
			customPaging: function(slider, i) {
				return '<button type="button" data-role="none"></button>';
			},
			slide: slideQuery,
			asNavFor: $slider
		});

		$wrap.on('click', slideQuery, function (event) {
			event.preventDefault();
		})
	});
};